import script from "./MaterialSelectionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialSelectionModal.vue?vue&type=script&setup=true&lang=js"

import "./MaterialSelectionModal.vue?vue&type=style&index=0&id=4e0dc8f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e0dc8f8"]])

export default __exports__